<template>
  <v-tooltip bottom max-width="320">
    <template #activator="{ on, attrs }">
      <v-icon
        small
        color="grey"
        class="glossary-tip"
        tabindex="0"
        v-bind="attrs"
        v-on="on"
      >
        mdi-help-circle-outline
      </v-icon>
    </template>
    <div class="font-weight-medium mb-1">{{ $t('glossary_' + term) }}</div>
    <div>{{ $t('glossary_' + term + '_hint') }}</div>
  </v-tooltip>
</template>

<script>
/*
 * What a word in this application means.
 *
 * Route, stop and trip are the three the panel is built out of and the three
 * nobody arrives knowing, because they are ordinary English words used in a
 * particular way: a stop is a place, a route is the order of the places, and a
 * trip is the route actually running - at a time, on a date, with a driver.
 * A school confronted with three dropdowns labelled Route, Stop and Trip has
 * no way to work that out except by trying combinations.
 *
 * One component and one set of strings, so the answer is the same wherever it
 * is asked, and so adding it to a screen is one tag rather than a paragraph
 * somebody has to write again slightly differently.
 */
export default {
  name: "GlossaryTip",
  props: {
    term: {
      type: String,
      required: true,
      validator: (value) =>
        ["route", "stop", "trip", "planned_trip", "mapping", "coin"].indexOf(value) !== -1,
    },
  },
};
</script>

<style scoped>
.glossary-tip {
  cursor: help;
  vertical-align: middle;
}
</style>
